import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/PaperPlaneTilt.es.js";
const a = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...o, weights: n }));
a.displayName = "PaperPlaneTiltIcon";
const m = a;
export {
  m as PaperPlaneTilt,
  a as PaperPlaneTiltIcon
};
